import styled, { CSSObject } from '@emotion/styled'
import UAParser from 'ua-parser-js'
import ScrollVideoByPlayback from './ScrollVideoByPlayback'
import ScrollVideoBySeek from './ScrollVideoBySeek'
import { VIEWPORT_HEIGHT } from '../../../../util/viewportHeight'

export interface ScrollVideoProps {
  videoLandscape: string
  videoPortrait: string
  isActive: boolean
  scrollPercentage: number
  alt: string
  videoId: string
}

export default function ScrollVideo(props: ScrollVideoProps) {
  const uaParser = new UAParser()

  if (uaParser.getBrowser().name === 'Firefox') {
    return <ScrollVideoByPlayback {...props} />
  } else {
    return <ScrollVideoBySeek {...props} />
  }
}

interface PosterProps {
  posterIsVisible: boolean
  posterUrl: string
}

export const Poster = styled.div<PosterProps>`
  position: absolute;
  opacity: ${(props) => (props.posterIsVisible ? '1' : '0')};
  transition: opacity 0.5s ease-in-out;
  height: ${VIEWPORT_HEIGHT};
  width: 100%;
  background-image: url(${(props) => props.posterUrl});
  background-position: center;
  background-size: cover;
`

export const VideoContainer = styled.div(
  (): CSSObject => ({
    position: 'relative',
    width: '100%',
    height: VIEWPORT_HEIGHT,
    '& .video-player': {
      position: 'absolute',
      zIndex: 2,
      '& > video': {
        objectFit: 'cover',
      },
    },
  })
)
